import * as Draft from 'draft-js';

export const findWithRegex = (
  regex: RegExp,
  contentBlock: Draft.ContentBlock,
  callback: (startIndex: number, endIndex: number) => void
) => {
  const text = contentBlock.getText();

  let matchArr, start;

  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;

    callback(start, start + matchArr[0].length);
  }
};
